import { isNil } from 'lodash';
import {
  IChartSettings,
  IParsedChartDataFunnel,
  IParsedFunnelColumn,
} from '../../../interfaces';
import { filterVisibleColumnsBySlice, IChartLine } from '../../useChartLines';
import { getSelectedFunnelModeSlice } from './utils';
import {
  getMeasureColorFromColorConfig,
  getSliceColorFromColorConfig,
  IAnalysisColorConfig,
} from '../../../utils/analysisColorConfig';

const getFrequencyLines = (
  sortedColumns: IParsedFunnelColumn[],
  chartData: IParsedChartDataFunnel,
  chartSettings: IChartSettings,
  colorConfig: IAnalysisColorConfig,
  shouldUseMeasureColor: boolean,
): IChartLine[] => {
  const { funnelModeSlice } = getSelectedFunnelModeSlice(
    chartData,
    chartSettings,
  );
  if (isNil(funnelModeSlice)) {
    return [];
  }

  const selectedFunnelModeSliceKey = funnelModeSlice.key;

  const visibleColumnsBySlice = filterVisibleColumnsBySlice(
    sortedColumns,
    chartSettings,
  );

  const visibleColumnsBySliceAndFunnelMode = visibleColumnsBySlice.filter(
    (c) => c.funnelModeSliceKey === selectedFunnelModeSliceKey,
  );

  return visibleColumnsBySliceAndFunnelMode.map((column) => {
    const color = shouldUseMeasureColor
      ? getMeasureColorFromColorConfig(
          colorConfig,
          funnelModeSlice.firstMeasureKey,
        )
      : getSliceColorFromColorConfig(colorConfig, column.sliceKey);

    return {
      name: column.key,
      display: column.name,
      color,
      type: 'normal',
      measureKey: column.measureKey,
    };
  });
};

export default getFrequencyLines;
